


























































































































import Vue, { PropType } from "vue"
import PAgeSearchFilter, { AgeModel } from "./searchKit/PAgeSearchFilter.vue"
import PAvailableUptimeSearchFilter from "./searchKit/PAvailableUptimeSearchFilter.vue"
import PJobCategorySearchFilter from "./searchKit/PJobCategorySearchFilter.vue"
import PLastAccessFilter from "./searchKit/PLastAccessFilter.vue"
import PPrefectureSearchFilter from "./searchKit/PPrefectureSearchFilter.vue"
import PWorkingFormSearchFilter from "./searchKit/PWorkingFormSearchFilter.vue"
import FilterList from "~/components/custom/search/pcSearchKit/FilterList.vue"
import FilterListItem from "~/components/custom/search/pcSearchKit/FilterListItem.vue"
import TextField from "~/components/guideline/search/TextField.vue"
import { SearchParams } from "~/clStores/profileSearchList"
import {
  JobCategoryOption,
  NormalOption,
  AgeOption,
} from "~/clStores/profileSearchParameterOption"
export { SearchParams } from "~/clStores/profileSearchList"
export {
  JobCategoryOption,
  NormalOption,
  AgeOption,
} from "~/clStores/profileSearchParameterOption"

export interface SearchResult {
  /**
   * 条件にヒットしたプロフィール数
   */
  numberOfTotalHits: number | null
}

type FilterType =
  | "PJobCategorySearchFilter"
  | "PAvailableUptimeSearchFilter"
  | "PLastAccessFilter"
  | "PPrefectureSearchFilter"
  | "PWorkingFormSearchFilter"
  | "PAgeSearchFilter"

interface DataType {
  visibleFilter: FilterType | null
}

export default Vue.extend({
  components: {
    TextField,
    PAgeSearchFilter,
    PAvailableUptimeSearchFilter,
    PJobCategorySearchFilter,
    PLastAccessFilter,
    PPrefectureSearchFilter,
    PWorkingFormSearchFilter,
    FilterList,
    FilterListItem,
  },
  props: {
    /**
     * 検索パラメータの値
     * v-modelで操作する。
     */
    value: {
      type: Object as PropType<SearchParams>,
      required: true,
    },
    // 認証済みユーザーかどうかの判定フラグ
    isFullParameterSearch: {
      type: Boolean,
      required: true,
    },
    // 職種カテゴリーの選択肢一覧
    jobCategoryOptions: {
      type: Array as PropType<JobCategoryOption[]>,
      required: true,
    },
    availableUptimeOptions: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
    sinceLastAccessDaysOptions: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
    prefectureOptions: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
    workingFormOptions: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
    ageOptions: {
      type: Array as PropType<AgeOption[]>,
      required: true,
    },
    hasAnySearchParams: {
      type: Boolean,
      required: true,
    },
    searchResult: {
      type: Object as PropType<SearchResult>,
      default: null,
    },
  },
  data(): DataType {
    return {
      /**
       * 表示中のフィルター
       */
      visibleFilter: null,
    }
  },
  computed: {
    numberOfTotalHitsText(): string {
      const numberOfTotalHits = this.searchResult?.numberOfTotalHits
      if (!numberOfTotalHits && numberOfTotalHits !== 0) {
        return "該当者 -"
      }
      return numberOfTotalHits > 1000
        ? "該当者 1,000 名以上"
        : `該当者 ${numberOfTotalHits.toLocaleString()} 名`
    },
    jobCategoryFieldText() {
      const length = this.value.smallJobCategoryIds.length
      return length ? `職種：${length}` : "職種"
    },
    availableUptimeFieldText() {
      if (this.value.availableUptimeIds.length === 0) {
        return "稼働時間"
      }

      const times = this.value.availableUptimeIds
      return times.length === 1
        ? `週${times[0]}日` // １つのみ選択している場合
        : `週${times[0]}〜${times[times.length - 1]}日` // 複数選択している場合
    },
    lastAccessFieldText() {
      if (!this.value.sinceLastAccessDays) {
        return "最終アクセス"
      }
      return `最終アクセス：${this.value.sinceLastAccessDays}日以内にアクセス`
    },
    prefectureFieldText() {
      const length = this.value.prefectureIds.length
      return length ? `地域：${length}` : "居住地域"
    },
    workingFormFieldText(): string {
      const workingFormlabel =
        this.workingFormOptions.find(
          (o) => o.value === this.value.workingFormId
        )?.label || null

      return workingFormlabel ? `稼働形態：${workingFormlabel}` : "稼働形態"
    },
    ageFieldText() {
      const minAgeLabel =
        this.ageOptions.find((o) => o.minAgeValue === this.value.minAge)
          ?.minAgeLabel || null
      const maxAgeLabel =
        this.ageOptions.find((o) => o.maxAgeValue === this.value.maxAge)
          ?.maxAgeLabel || null
      return minAgeLabel && maxAgeLabel
        ? `${minAgeLabel}〜${maxAgeLabel}`
        : "年齢"
    },
    ageValue() {
      return { min: this.value.minAge, max: this.value.maxAge }
    },
  },
  methods: {
    toggleFilter(filterType: FilterType) {
      this.visibleFilter = filterType === this.visibleFilter ? null : filterType
    },
    changeSearchWord(newVal: string) {
      this.handleInput({
        ...this.value,
        searchWord: newVal,
      })
    },
    changeSmallJobCategoryIds(newVal: number[]) {
      this.handleInput({
        ...this.value,
        smallJobCategoryIds: newVal,
      })
      this.handleSearch()
    },
    changeAvailableUptimeIds(newVal: number[]) {
      this.handleInput({
        ...this.value,
        availableUptimeIds: newVal,
      })
      this.handleSearch()
    },
    changeSinceLastAccessDays(newVal: number | null) {
      this.handleInput({
        ...this.value,
        sinceLastAccessDays: newVal,
      })
      this.handleSearch()
    },
    changePrefectureIds(newVal: number[]) {
      this.handleInput({
        ...this.value,
        prefectureIds: newVal,
      })
      this.handleSearch()
    },
    changeWorkingFormId(newVal?: number) {
      this.handleInput({
        ...this.value,
        workingFormId: newVal,
      })
      this.handleSearch()
    },
    changeAges(newVal: AgeModel) {
      this.handleInput({
        ...this.value,
        minAge: newVal.min,
        maxAge: newVal.max,
      })
      this.handleSearch()
    },
    handleClickDisabledFilter() {
      this.$emit("click-disabled-filter")
    },
    handleInput(arg: SearchParams) {
      this.$emit("input", arg)
    },
    clear() {
      this.visibleFilter = null
      this.handleInput({
        searchWord: "",
        smallJobCategoryIds: [],
        availableUptimeIds: [],
        sinceLastAccessDays: null,
        prefectureIds: [],
        workingFormId: this.isFullParameterSearch ? 1 : undefined,
        minAge: null,
        maxAge: null,
      })
      this.handleSearch()
    },
    handleSearch() {
      this.$emit("search")
    },
  },
})
